import { SpeakerWithDetails } from '@/player-config/src/types/speaker-types';

export const getSpeakerName = (speaker: Partial<SpeakerWithDetails>) => {
  let name = '';
  if (speaker.first_name) {
    name += speaker.first_name;
  }
  if (speaker.last_name && name.length > 0) {
    name += ' ';
  }
  if (speaker.last_name) {
    name += speaker.last_name;
  }
  if (name.length === 0) {
    return 'Speaker without name';
  }
  return name;
};
